import KeyboardArrowDownRounded from "@mui/icons-material/KeyboardArrowDownRounded";
import KeyboardArrowUpRounded from "@mui/icons-material/KeyboardArrowUpRounded";
import { IconButton, Tooltip } from "@mui/material";
import Button from "@mui/material/Button";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { blue } from "@mui/material/colors";
import isFunction from "lodash/isFunction";
import React, { useMemo } from "react";

const DropdownButton = ({
  options,
  children,
  startIcon,
  showDropdownArrow = false,
  color,
  size = "small",
  loading,
  iconTooltip,
  variant = "contained",
  icon = null,
  endIcon = <KeyboardArrowDownRounded />,
  id = "dropdown-button",
  sx = {},
}) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const styles = useMemo(() => {
    let sty = {};
    if (open) {
      sty = {
        backgroundColor: variant === "outlined" ? blue[50] : blue[900],

        fontWeight: 600,
      };
    }
    return {
      ...sty,
      ...sx,
    };
  }, [sx, open, variant]);

  const handleClose = (fn) => {
    if (isFunction(fn)) {
      fn();
    }
    setAnchorEl(null);
  };

  return (
    <>
      {icon ? (
        <Tooltip title={iconTooltip}>
          <IconButton
            id={id}
            aria-controls={open ? "demo-customized-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
            size={size}
            color={color}
            sx={sx}
            onClick={handleClick}
          >
            {icon}
          </IconButton>
        </Tooltip>
      ) : (
        <Button
          id={id}
          aria-controls={open ? "demo-customized-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          variant={variant}
          size={size}
          loading={loading}
          color={color}
          disableElevation
          startIcon={startIcon}
          sx={styles}
          onClick={handleClick}
          endIcon={
            showDropdownArrow && open ? <KeyboardArrowUpRounded /> : endIcon
          }
        >
          {children}
        </Button>
      )}
      <Menu
        id="demo-customized-menu"
        MenuListProps={{
          "aria-labelledby": id,
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        {options?.map((o, i) => {
          return (
            <MenuItem
              key={i}
              disabled={o?.disabled}
              onClick={() => handleClose(o?.onClick)}
              disableRipple
              sx={{
                ".MuiListItemIcon-root ": {
                  minWidth: "36px",
                  // minWidth: "24px",
                  ".MuiSvgIcon-root": {
                    fontSize: "16px",
                  },
                },
              }}
            >
              {o?.icon || o?.startIcon ? (
                <ListItemIcon>{o?.icon || o?.startIcon}</ListItemIcon>
              ) : null}

              <ListItemText sx={{ span: { fontSize: "12px" } }}>
                {o?.label}
              </ListItemText>
              {o?.endIcon ? <ListItemIcon>{o?.endIcon}</ListItemIcon> : null}
            </MenuItem>
          );
        })}
      </Menu>
    </>
  );
};

export default DropdownButton;
